// src/App.js
// Drop ComingSoon.jsx into src/ alongside this file, then render it here.

import ComingSoon from "./ComingSoon";
//import Web2SMSWhatsApp from "./Web2SMSWhatsApp";

function App() {
  return <ComingSoon />;
  //return <Web2SMSWhatsApp />;
}

export default App;
